// Saga

export const createSale = (
    amount: number
): sage.actions.balance.ICreateSale => {
    return {
        type: "com.sage.actions.balance.ICreateSale",
        amount,
    };
};

export const createOrder = (
    minutes: number,
    priceCentHundredths: number
): sage.actions.balance.ICreateOrder => {
    return {
        type: "com.sage.actions.balance.ICreateOrder",
        minutes,
        priceCentHundredths,
    };
};

export const fetchSales = (page: number): sage.actions.balance.IFetchSales => {
    return {
        type: "com.sage.actions.balance.IFetchSales",
        page,
    };
};

export const fetchOrders = (
    page: number
): sage.actions.balance.IFetchOrders => {
    return {
        type: "com.sage.actions.balance.IFetchOrders",
        page,
    };
};

export const fetchMoneyEntries = (
    page: number
): sage.actions.balance.IFetchMoneyEntries => {
    return {
        type: "com.sage.actions.balance.IFetchMoneyEntries",
        page,
    };
};

export const createTransfer = (
    amountCentHundredths: number
): sage.actions.balance.ICreateTransfer => {
    return {
        type: "com.sage.actions.balance.ICreateTransfer",
        amountCentHundredths,
    };
};

export const fetchTransfers = (
    page: number
): sage.actions.balance.IFetchTransfers => {
    return {
        type: "com.sage.actions.balance.IFetchTransfers",
        page,
    };
};

export const fetchMarketPrice = (): sage.actions.balance.IFetchMarketPrice => {
    return {
        type: "com.sage.actions.balance.IFetchMarketPrice",
    };
};

export const createAddMoney = (
    centHundredths: number
): sage.actions.balance.ICreateAddMoney => ({
    type: "com.sage.actions.balance.ICreateAddMoney",
    centHundredths,
});

export const cancelOrder = (
    orderId: string
): sage.actions.balance.ICancelOrder => ({
    type: "com.sage.actions.balance.ICancelOrder",
    orderId,
});

export const cancelSale = (
    saleId: string
): sage.actions.balance.ICancelSale => ({
    type: "com.sage.actions.balance.ICancelSale",
    saleId,
});

// Redux

export const setSales = (
    page: number,
    sales: sage.model.ISale[]
): sage.actions.balance.ISetSales => {
    return {
        type: "com.sage.actions.balance.ISetSales",
        page,
        sales,
    };
};

export const setSalesStatus = (
    page: number,
    status: sage.status.Fetch
): sage.actions.balance.ISetSalesStatus => {
    return {
        type: "com.sage.actions.balance.ISetSalesStatus",
        page,
        status,
    };
};

export const setOrders = (
    page: number,
    orders: sage.model.IOrder[]
): sage.actions.balance.ISetOrders => {
    return {
        type: "com.sage.actions.balance.ISetOrders",
        page,
        orders,
    };
};

export const setOrdersStatus = (
    page: number,
    status: sage.status.Fetch
): sage.actions.balance.ISetOrdersStatus => {
    return {
        type: "com.sage.actions.balance.ISetOrdersStatus",
        page,
        status,
    };
};

export const setCreateSaleStatus = (
    status: sage.status.CreateSale
): sage.actions.balance.ISetCreateSaleStatus => {
    return {
        type: "com.sage.actions.balance.setCreateSaleStatus",
        status,
    };
};

export const resetSalesFetch = (): sage.actions.balance.IResetSalesFetch => {
    return {
        type: "com.sage.actions.balance.IResetSalesFetch",
    };
};

export const setCreateOrderStatus = (
    status: sage.status.CreateOrder
): sage.actions.balance.ISetCreateOrderStatus => {
    return {
        type: "com.sage.actions.balance.ISetCreateOrderStatus",
        status,
    };
};

export const resetOrdersFetch = (): sage.actions.balance.IResetOrdersFetch => {
    return {
        type: "com.sage.actions.balance.IResetOrdersFetch",
    };
};

export const resetMoneyEntriesFetch = (): sage.actions.balance.IResetMoneyEntriesFetch => {
    return {
        type: "com.sage.actions.balance.IResetMoneyEntriesFetch",
    };
};

export const setMoneyEntries = (
    page: number,
    moneyEntries: sage.model.IMoneyEntry[]
): sage.actions.balance.ISetMoneyEntries => {
    return {
        type: "com.sage.actions.balance.ISetMoneyEntries",
        page,
        moneyEntries,
    };
};

export const setMoneyEntriesStatus = (
    page: number,
    status: sage.status.Fetch
): sage.actions.balance.ISetMoneyEntriesStatus => {
    return {
        type: "com.sage.actions.balance.ISetMoneyEntriesStatus",
        page,
        status,
    };
};

export const setCreateTransferStatus = (
    status: sage.status.CreateTranfer
): sage.actions.balance.ISetCreateTransferStatus => {
    return {
        type: "com.sage.actions.balance.ISetCreateTransferStatus",
        status,
    };
};

export const resetTransfersFetch = (): sage.actions.balance.IResetTransfersFetch => {
    return {
        type: "com.sage.actions.balance.IResetTransfersFetch",
    };
};

export const setTranfers = (
    page: number,
    transfers: sage.model.ITransfer[]
): sage.actions.balance.ISetTransfers => {
    return {
        type: "com.sage.actions.balance.ISetTransfers",
        page,
        transfers,
    };
};

export const setFetchTransfersStatus = (
    page: number,
    status: sage.status.Fetch
): sage.actions.balance.ISetFetchTransfersStatus => {
    return {
        type: "com.sage.actions.balance.ISetFetchTransfersStatus",
        page,
        status,
    };
};

export const setMarketPriceStatus = (
    status: sage.status.Fetch
): sage.actions.balance.ISetMarketPriceStatus => {
    return {
        type: "com.sage.actions.balance.ISetMarketPriceStatus",
        status,
    };
};

export const setMarketPrice = (
    marketPrice: sage.model.IMarketPrice
): sage.actions.balance.ISetMarketPrice => {
    return {
        type: "com.sage.actions.balance.ISetMarketPrice",
        marketPrice,
    };
};

export const setCreateAddMoneyStatus = (
    status: sage.status.AddMoneyStatus
): sage.actions.balance.ISetAddMoneyStatus => {
    return {
        type: "com.sage.actions.balance.ISetAddMoneyStatus",
        status,
    };
};

export const setCancelOrderStatus = (
    status: sage.status.CancelStatus,
    orderId: string
): sage.actions.balance.ICancelOrderStatus => {
    return {
        type: "com.sage.actions.balance.ICancelOrderStatus",
        status,
        orderId,
    };
};

export const setCancelSaleStatus = (
    status: sage.status.CancelStatus,
    saleId: string
): sage.actions.balance.ISetCancelSaleStatus => {
    return {
        type: "com.sage.actions.balance.ISetCancelSaleStatus",
        status,
        saleId,
    };
};
